
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
  name: 'MainCharacters',

  setup() {
    const mainCharacters = ref([] as any);

    onMounted(async () => {
      const res = await fetch(
        'https://rickandmortyapi.com/api/character/5,7,11,183,14,20,1,2,3,4,'
      );

      const data = await res.json();
      mainCharacters.value = data;
      console.log(mainCharacters.value);
    });

    const sortByName = async () => {
      mainCharacters.value.sort((a: any, b: any) =>
        a.name.localeCompare(b.name)
      );
    };

    const sortByCreated = async () => {
      mainCharacters.value.sort((a: any, b: any) => {
        return b.created.localeCompare(a.created);
      });
    };

    return {
      mainCharacters,
      sortByName,
      sortByCreated,
    };
  },
});
